import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AccountState } from './account.reducer';

export const selectAccountState = createFeatureSelector('account');

export const getAccount = createSelector(
    selectAccountState,
    (state: AccountState) => state.account
);
